export default "__VITE_ASSET__jjQ9Rc50__"